import { useCallback, useMemo, useState } from 'react';
import { ContactInfoFieldKeyType } from 'typings/form';
import { filterContactInfo, shouldShowSeeMore } from 'utils/contactUtils';

export const useContactPersonCard = (contacts: Record<ContactInfoFieldKeyType, string[]>) => {
  const [isAllShown, setIsAllShown] = useState<boolean>(false);

  const isSeeAllVisible = shouldShowSeeMore(contacts);
  const personContactInfo = useMemo(() => {
    return filterContactInfo(contacts, isAllShown);
  }, [contacts, isAllShown]);

  const onShowAllStateChange = useCallback(() => {
    setIsAllShown((prevState) => !prevState);
  }, []);

  return {
    onShowAllStateChange,
    isAllShown,
    isSeeAllVisible,
    personContactInfo,
  };
};
